// it would be nice to remove this and pass in the values so this code has no dependancy on next
import getConfig from 'next/config';

export const getApiKey = (country: string | undefined) =>
  country && country !== 'GB'
    ? getConfig().publicRuntimeConfig.loqate.intlKey
    : getConfig().publicRuntimeConfig.loqate.gbKey;
